var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
var defaultTheme = (_a = {},
    _a['themeButtons'] = 'dark-mode',
    _a['themeEvent'] = 'click',
    _a['themeDark'] = 'dark',
    _a);
var themeButtons = defaultTheme.themeButtons, themeEvent = defaultTheme.themeEvent, themeDark = defaultTheme.themeDark;
var toggleThemeBtn = Array.from(document.getElementsByClassName(themeButtons));
export default function toggleTheme(document, options) {
    if (options === void 0) { options = defaultTheme; }
    defaultTheme = __assign(__assign({}, defaultTheme), options);
    toggleThemeBtn.forEach(function (btn) {
        btn.addEventListener(themeEvent, function () {
            document.documentElement.toggleAttribute(themeDark);
        });
    });
}
